import { render, staticRenderFns } from "./PhoneField.dynamic.vue?vue&type=template&id=73e97ddb&"
import script from "./PhoneField.dynamic.vue?vue&type=script&lang=js&"
export * from "./PhoneField.dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports